import { Transition, Box } from '@mantine/core';
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

export interface PopTransitionProps {
  children: React.ReactNode;
  visible?: boolean;
  duration?: number;
  delay?: number;
}

/**
 * Pop animation with bounce effect using Mantine's pop transition
 */
const PopTransition = forwardRef<HTMLDivElement, PopTransitionProps>(
  (
    {
      children,
      visible = true,
      duration = 200,
      delay = 0,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();
    const actualDuration = reducedMotion ? 0 : duration;

    return (
      <Transition
        mounted={visible}
        transition="pop"
        duration={actualDuration}
        timingFunction="cubic-bezier(0.34, 1.56, 0.64, 1)"
      >
        {(styles) => (
          <Box
            ref={ref}
            style={{
              ...styles,
              transitionDelay: reducedMotion ? '0ms' : `${delay}ms`,
            }}
          >
            {children}
          </Box>
        )}
      </Transition>
    );
  }
);

PopTransition.displayName = 'PopTransition';

export default PopTransition;
